import { PortfolioGuidFilterType, useRepositoryMutation, useRepositoryQuery } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useAddCentralProducts = () =>
    useRepositoryMutation('portfolioCentralProducts', 'add', {
        invalidateQueries: { portfolioCentralProducts: ['getOverviewEntries'] }, // TODO this will be moved to after assigning property
        onSuccess: () =>
            showSuccessAlert({
                title: lt('CentralProductCreated'),
                description: lt('CentralProductCreatedDescription'),
            }),
    });

export const useEnterpriseRelationships = (enterpriseIds: string[]) =>
    useRepositoryQuery(
        'portfolioEnterpriseRelationships',
        'getAll',
        {
            pagination: { pageSize: 0, pageIndex: 0 },
            filters: {
                enterpriseIds: enterpriseIds.map((id) => ({ value: id, filterType: PortfolioGuidFilterType.Equals })),
            },
        },
        { enabled: enterpriseIds.length > 0 }
    );

export const useAddPortfolioEnterpriseProducts = () =>
    useRepositoryMutation('portfolioEnterpriseProducts', 'add', {
        invalidateQueries: {
            portfolioCentralProducts: ['getOverviewEntries'],
            portfolioProducts: ['getOverviewEntries'],
            portfolioEnterpriseProducts: ['getConfigurationEntries'],
        },
        onSuccess: (_, variables) =>
            showSuccessAlert({
                title: lt('ConfigureProductMultiplePropertiesSuccess', { count: variables.enterpriseProducts.length }),
            }),
    });

export const useUpdateCentralProducts = () =>
    useRepositoryMutation('portfolioCentralProducts', 'update', {
        invalidateQueries: {
            portfolioCentralProducts: ['getOverviewEntries', 'getDetail'],
            portfolioEnterpriseProducts: ['getDetail'],
        },
        onSuccess: () =>
            showSuccessAlert({
                title: lt('CentralProductUpdated'),
            }),
    });
